import { throwError } from '@/utils'
import { NativeInit, NativeRequest } from 'onemt-sdk-native'
import langAdaptor from 'onemt-lang-adaptor'
import { useStore } from '@/store'
import { useEffect, useRef, useState } from 'react'
import { createRequest } from '@/request/create'
import appExpose from '@app/expose'
import { getToken } from '@/request/utils'

const { config } = appExpose
const ENV = process.env.ENV
const BASE_URL_2 = process.env.BASE_URL_2
const VERSION = process.env.VERSION
const inSDK = window.inSDK

if (inSDK) {
  NativeInit({
    mocks: {
      getUser: {
        sessionId:
          '9Q2AxIEMHChXonkcqI/Wg4J2Ynur7oSWM4+tZNS95bodZkC/PX8IY+QVWdL+3daB7KZBv9ObCu1bN9R4ho9e+g==',
        userId: 'ce93a3118f1bbda00b1e0507e40c122f',
      },
      getConfig: {
        appId: '100010017',
        appKey: '29231eaf1157f68a8f15e27eb0d23179',
        appLang: 'zh-CN',
        appName: "Google正测King's Choice",
        appVersion: '1.3000.20.12',
        channel: 'googleplay',
        clientVersion: '5.9.0',
        deviceId: '44a0e8f2d24bba14121ae584c6548fb2',
        deviceLang: 'zh',
        gameVersion: '1.3000.20.12',
        originalId: '4F6D692D-5456-41A6-8208-ABD5F2B19CE3',
        packageName: 'com.onemt.and.kc.test',
        platform: 'android',
        sdid: '4F6D692D-5456-41A6-8208-ABD5F2B19CE3',
      },
      getGamePlayer: {
        ext: {},
        playerId: '5035810011',
        playerName: 'Noble357273',
        serverId: '10011',
        zoneId: '1',
      },
    },
  })
}

export default function useUserInfo() {
  const { state } = useStore()
  const [lang, setLang] = useState('')
  const gamePlayer = useRef(state.login.gamePlayer)
  const sdkConfig = useRef(state.login.sdkConfig)
  const userInfo = useRef(state.login.userInfo)

  const DEFAULT_LANG = config.defaultLang
  let LANG_LIST: Array<string>
  let browserLang: string
  try {
    LANG_LIST = JSON.parse(process.env.LANG_LIST as string)
    browserLang = !window.lang ? navigator.language : window.lang
    browserLang = LANG_LIST.includes(browserLang) ? browserLang : DEFAULT_LANG
  } catch (error) {
    throwError(error)
  }

  const initCount = useRef(0)
  useEffect(() => {
    const _run = async () => {
      console.log('初始化用户信息...')
      try {
        if (inSDK) {
          const user = await NativeRequest<User>('getUser', null, 5000)
          const _sdkConfig = await NativeRequest<typeof state.login.sdkConfig>(
            'getConfig',
            null,
            5000
          )
          sdkConfig.current = _sdkConfig
          const _gamePlayer = await NativeRequest<
            typeof state.login.gamePlayer
          >('getGamePlayer', { encode: true }, 5000)
          gamePlayer.current = _gamePlayer
          userInfo.current = {
            lang: _sdkConfig.appLang || browserLang,
            userId: user.userId,
            sessionId: user.sessionId,
            playerType: 1,
            playerId: '',
            playerName: '',
            serverId: '',
            serverName: '',
            zoneId: 0,
            checked: 0,
            justBinded: false,
            isBinded: false,
            isCodeBinded: false,
          }
          window.macaddr = userInfo.current.sessionId
        } else {
          userInfo.current = {
            lang: browserLang,
            userId: '',
            sessionId: getToken() || '',
            playerType: 1,
            playerId: '',
            serverId: '',
            serverName: '',
            playerName: '',
            zoneId: 0,
            checked: 0,
            justBinded: false,
            isBinded: false,
            isCodeBinded: false,
          }
        }
      } catch (error) {
        userInfo.current = {
          lang: browserLang,
          userId: '',
          sessionId: getToken() || '',
          playerType: 1,
          playerId: '',
          serverId: '',
          serverName: '',
          playerName: '',
          zoneId: 0,
          checked: 0,
          justBinded: false,
          isBinded: false,
          isCodeBinded: false,
        }
        throwError(error)
      }
      const _lang = (window.lang = langAdaptor(userInfo.current.lang))
      document.documentElement.setAttribute('lang', _lang)
      document.documentElement.classList.add(`lang-${_lang}`)
      document.documentElement.setAttribute(
        'ea-lang',
        ['zh-CN', 'zh-TW', 'ko', 'ja'].includes(_lang) ? '1' : '0'
      )
      document.documentElement.setAttribute(
        'dir',
        _lang === 'ar' ? 'rtl' : 'ltr'
      )

      const fontHref = `${BASE_URL_2}assets/font/NotoSansCJKhk.${_lang}.${VERSION}.woff2`
      const styleElem = document.createElement('style')
      styleElem.id = 'font-style'
      styleElem.textContent = `@font-face { font-family: 'NotoSansCJK'; src: url(${fontHref}) format('woff2'); font-display: swap; }`
      document.head.appendChild(styleElem)

      setLang(_lang)

      window.userInfo = userInfo.current
      window.sdkConfig = sdkConfig.current
      window.gamePlayer = gamePlayer.current
      createRequest(userInfo.current, sdkConfig.current, gamePlayer.current)
    }
    if (initCount.current === 0) {
      initCount.current++
      _run()
    }

    return () => {
      const styleElem = document.getElementById('font-style')
      if (styleElem) {
        styleElem.remove()
      }

      const prerenderElem = document.getElementById('prerender')
      if (prerenderElem) {
        prerenderElem.remove()
      }

      const iframeElem = document.getElementById('iframe')
      if (iframeElem) {
        iframeElem.remove()
      }
    }
  }, [])

  return {
    lang,
    gamePlayer: gamePlayer.current,
    sdkConfig: sdkConfig.current,
    userInfo: userInfo.current,
  }
}
